import type { Analise, ItemResumo } from '@sc/shared/triagem';

export interface Chip {
  valor: string;
  rotulo: string;
}

export interface ChatMessage {
  id: number | string;
  de: 'assistente' | 'pessoa';
  texto: string;
  chips?: Chip[];
  resumo?: ItemResumo[];
  analise?: Analise;
  formulario?: boolean;
}

export interface ChatState {
  passo: string;
  etapa: string;
  objetivo: 'instalar' | 'manutencao' | null;
  desfecho: 'qualificado' | 'fora_do_perfil' | 'encerrado_pela_pessoa' | null;
  podeVoltar: boolean;
  /** Só existe depois que o formulário foi enviado com sucesso. */
  linkWhatsapp?: string | null;
}

export interface ChatView {
  messages: ChatMessage[];
  estado: ChatState;
}

export type Entrada =
  | { tipo: 'escolha'; valor: string }
  | { tipo: 'texto'; texto: string }
  | { tipo: 'voltar' }
  | { tipo: 'encerrar' }
  | { tipo: 'arquivo' };

/** Etapas mostradas à pessoa, na ordem. */
export const ETAPAS = ['Seu projeto', 'Conta de luz', 'Localização', 'Detalhes', 'Contato'] as const;

export function etapaAtual(e: ChatState | null): number {
  if (!e) return 1;
  if (e.desfecho === 'qualificado') return 5;
  switch (e.passo) {
    case 'objetivo':
    case 'imovel':
    case 'apto_area':
    case 'manutencao':
      return 1;
    case 'conta':
    case 'conta_valor':
      return 2;
    case 'cep':
    case 'cidade':
      return 3;
    case 'propriedade':
    case 'local':
    case 'pagamento':
    case 'prazo':
      return 4;
    default:
      return 4;
  }
}

/** Passos em que o teclado numérico ajuda no celular. */
export const PASSOS_NUMERICOS = new Set(['conta', 'conta_valor', 'cep']);

export function placeholderDo(passo: string | undefined): string {
  switch (passo) {
    case 'conta':
    case 'conta_valor':
      return 'Ex.: 450';
    case 'cep':
      return 'Ex.: 04612-060';
    case 'cidade':
      return 'Nome da cidade';
    case 'manutencao':
      return 'Descreva o problema';
    default:
      return 'Digite ou toque numa opção';
  }
}
